import React, { useContext } from 'react';
import DomainData from '../../assets/datasets/DomainData';
import { AuthContext } from '../context/Auth';
import CheckField from '../forms/CheckField';
import PlacesAutoComplete from '../forms/PlacesAutoComplete';
import SelectField from '../forms/SelectField';

const Filter = ({ setFilter, filter, search, setSearch }) => {
  return (
    <div style={{ fontSize: 12 }}>
      {/* <b>Suchort</b>
      <PlacesAutoComplete
        map={mapInstance}
        mapApi={mapApi}
        setCenter={setCenter}
        setZoom={setZoom}
        setCenterAndZoomIn={setCenterAndZoomIn}
        setValue={setSearch}
        value={search}
        small
      /> */}
      <b>Fachgebiete</b>
      <SelectField
        options={[
          { label: 'Alle anzeigen', value: null },
          ...DomainData.areasOfExpertise.filter(aoe => !['Allgemeinmedizin', 'Bitte wählen...'].includes(aoe.label))
        ]}
        value={filter.departments ? filter.departments[0] : null}
        setValue={newDepartments => {
          if (newDepartments !== null) {
            setFilter('departments', [newDepartments]);
          } else {
            setFilter('departments', []);
          }
        }}
        style={{
          height: 42,
          border: '0.5px solid rgba(115, 115, 115, 0.4)',
          borderRadius: 6,
          fontSize: 12
        }}
      />
      <table>
        <tr>
          <td>Nur bewertete Kliniken</td>
          <td>&nbsp;&nbsp;<CheckField setValue={(v) => setFilter('rated', v)} value={filter.rated} /></td>
        </tr>
      </table>
    </div>
  );
};

export default Filter;
